export default {
  namespaced: true,
  state: {
    configData: {
      refreshTime: 3600000,
      countDown: 3600000,
    },
    refreshTimes: [
      {
        title: 'Kapalı',
        value: false,
      },
      {
        title: '5 Dakika',
        value: 300000,
      },
      {
        title: '15 Dakika',
        value: 900000,
      },
      {
        title: '30 Dakika',
        value: 1800000,
      },
      {
        title: '1 Saat',
        value: 3600000,
      },
    ],
  },
  getters: {
    configData(state) {
      return state.configData
    },
    refreshTimes(state) {
      return state.refreshTimes
    },
  },
  mutations: {},
  actions: {},
}
